<div>
    <h4>Edit ACH</h4>
    <div class="row mt-4">
        <h5 class="col-md-6">Editing information for account ending in {{ach.lastFourDigits}}</h5>
    </div>
    <div class="row">
        <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
    </div><br>

    <div class="row">
        <form class="col-11" [formGroup]="editAchForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="mb-3 col-md-10">
                    <label for="accountOwnerName">Account Owner Name</label>
                    <input class="form-control" readonly id="accountOwnerName" formControlName="accountOwnerName" />
                </div>
            </div>
               
             <div class="row">
                <div class="mb-3 col-md-5">
                    <label class="d-block" for="accountType" class="required">Account Type</label>
                    <p-dropdown appDd [options]="accountTypes" [filter]="true" optionLabel="name" id="accountType"
                        optionValue="type" formControlName="accountType" placeholder="Account Type" [disabled]="true">
                    </p-dropdown>

                </div>
            </div>

         <div class="row">
                <div class="mb-3 col-md-10">
                    <label for="description">Description</label>
                    <input id="description" class="form-control" appScrText formControlName="description" placeholder="Description"
                        maxlength="80" />
                </div>
            </div>
  
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="routingNumber" id="routingNumberLabel" class="required">Routing Number (9 Digits)</label>
                    <input class="form-control" appScrText formControlName="routingNumber" id="routingNumber"
                        appNumericOnly placeholder="Routing Number" maxlength="{{MaxLen.RoutingNumber}}" [readonly]="true"
                        [ngClass]="{'error-input': editAchForm.get('routingNumber')!.invalid && submitted === true}"  
                        />
                        <ng-container *ngIf="editAchForm.get('routingNumber')!.invalid && submitted === true">
                            <span *ngIf="editAchForm.get('routingNumber')!.errors?.required" class="failed">Routing Number is
                                required.</span>
                        </ng-container>
                </div>
            </div>
 
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="bankName" class="required">Bank Name</label>
                    <input class="form-control" appScrText formControlName="bankName" placeholder="Bank Name" id="bankName" 
                        maxlength="40"  [ngClass]="{'error-input': editAchForm.get('bankName')!.invalid && submitted === true}" />
                        <ng-container *ngIf="editAchForm.get('bankName')!.invalid && submitted === true">
                            <span *ngIf="editAchForm.get('bankName')!.errors?.required" class="failed">Bank Name is
                                required.</span>
                               
                        </ng-container>
                    </div>
            </div>
          
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="limit" id="maxPaymentLimitLabel" class="required">Maximum Payment Limit</label>
                    <p-inputNumber appIn #maxPaymentLimit formControlName="limit"
                                        mode="currency" currency="USD" locale="en-US" [size]="30"
                                        [min]="0.01" [max]="achMaxPaymentLimit" placeholder="Maximum Payment Limit"
                        [ngClass]="{'error-input': editAchForm.get('limit')!.invalid && submitted === true}"></p-inputNumber>
                    <ng-container *ngIf="editAchForm.get('limit')!.invalid && submitted === true">
                        <span *ngIf="editAchForm.get('limit')!.errors?.required" class="failed">Maximum Payment Limit is
                            required.</span>
                            <span *ngIf="editAchForm.get('limit')!.errors?.zero" class="failed">Invalid Maximum Payment Limit.</span>
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-8">
                    <p-checkbox class="p-formcontrol" label="Set as default" id="default" [binary]="true" value="false"
                        formControlName="defaultPaymentMethod"></p-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col small ms-3">
                    Setting this as the default payment method indicates that this payment method will be used for auto-renew.
                </div>
            </div>

            <div class="row mt-2">
                <div class="mb-3 col-md-8">
                    <label for="consent" class="required">
                        <p-checkbox class="p-formcontrol" label="Consent" id="consent" [binary]="true" value="false" name="consent"
                             formControlName="consent" [required]="true" [ngClass]="{'error-input': editAchForm.get('consent')!.invalid && submitted === true}"  ></p-checkbox>
                    </label>
                    <div class="error-msg" *ngIf="editAchForm.get('consent')!.errors?.required && editAchForm.get('consent')!.dirty">
                        <span class="failed">Please read the Consent Agreement regarding ACH withdrawals and click on the box to accept.</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col small ms-4">
                    I hereby authorize the payee to electronically debit my bank account for payments to the Short Code Registry not to exceed the amount 
                specified as the Maximum Payment Limit.<br><br>If a convenience fee is added to the transaction, I understand that the convenience fee will be included in the total payment amount. 
                <br><br>If a payment is returned for insufficient funds, I authorize the payee to electronically debit my account for the original amount of 
                the transaction, as well as a returned item fee, up to the maximum amount allowed by law.
                </div>
            </div>


            <div class="d-flex justify-content-start ps-3 mt-3">
                <button class="btn btn-primary me-3" submit>Update Payment Method</button>
                <button class="btn btn-secondary" type="button" (click)="confirmCancelDialog()">Cancel</button>
            </div>
            <p-confirmDialog key='confirmCancel' #creditFormCancel width="425" [closable]="false">
                <p-footer>
                    <div class="d-flex justify-content-end">
                        <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="creditFormCancel.accept()">Yes</button>
                        <button i18n id="screject" class="btn btn-secondary" type="button" (click)="creditFormCancel.reject()">No</button>
                    </div>
                </p-footer>
            </p-confirmDialog>
        </form>
    </div>
</div>
